<template>
  <div>
    <el-table :size="$vars.sizes.table || $vars.sizes.common" stripe :data="state.items" row-key="id" @row-click="rowClick" class="cards-table">
      <el-table-column prop="id" :label="$tf('id')" width="100"></el-table-column>
      <el-table-column prop="" :label="$tf('photo')" width="200">
        <template slot-scope="{ row }">
          <object-thumbnail :id="getMatchedObjectId(row)" :objects="objects" @preview="(v) => $store.dispatch('showImage', v)"></object-thumbnail>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$tf('card')">
        <template slot-scope="{ row }">
          <router-link name="item-btn" :to="{ path: getCardLink(row) }">
            <span>{{ row.name }}</span>
            <span v-if="!hasObjectsConfidence">({{ getConfidenceValue(row) | floatToPercent }})</span>
          </router-link>

          <confidence-label v-if="hasObjectsConfidence" :objects="objects" :value="getConfidenceValue(row)"></confidence-label>
          <br />
          {{ row.comment }}
          <watch-lists-inline :ids="row.watch_lists"></watch-lists-inline>
          <br />

          <div v-if="state.filter.current.sourceType === 'event'">
            <a
              v-if="!addedObjects[row.id]"
              v-loading="uploading"
              id="upload-event-face-card-btn"
              @click.prevent.stop="() => addObjectToCard(row.id)"
              class="link"
            >
              <i class="mar-left--1 el-icon-plus"></i> {{ $tfo(`add_event_to_card`) }}
            </a>
            <div v-else>
              {{ $tf('event_has_been_added_to_card') }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="role" :label="$tf('was_updated,, 1')" width="200">
        <template slot-scope="{ row }">
          {{ $filters.formatDate(row.modified_date) }}
          <br />
          {{ $filters.formatTime(row.modified_date) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator';
import { ObjectsType, ObjectsTypeSingleForm } from '@/store/objects/get.module';
import ObjectThumbnail from '../../../objects/thumbnail';
import WatchListsInline from '../../../watch-lists/inline';
import ConfidenceLabel from '../../../common/confidence.label';
import { objectsTypeToCardType } from '@/store/cards/cards';

@Component({
  components: { ConfidenceLabel, WatchListsInline, ObjectThumbnail },
  props: {
    state: {
      type: Object,
      required: true
    },
    objects: {
      type: String,
      default: ObjectsType.Faces
    }
  }
})
export default class CardsSearchResults extends Vue {
  addedObjects = [];
  uploading = false;

  addObjectToCard(cardId) {
    const eventId = this.state.filter.current.looks_like?.split(':')[1];
    if (!eventId) return;
    this.uploading = true;
    this.$store
      .dispatch('uploadObject', {
        create_from: `${ObjectsTypeSingleForm[this.objects]}event:${eventId}`,
        card: cardId,
        objects: this.objects
      })
      .then((v) => {
        this.addedObjects[cardId] = true;
        this.$notify({ type: 'success', message: this.$tf(['action', 'success']) });
      })
      .catch((e) => {
        this.$notify({ duration: 0, message: this.$createElement('message-box', { props: { e: e } }) });
      })
      .finally(() => {
        this.uploading = false;
      });
  }

  getCardLink(item) {
    let cardType = objectsTypeToCardType(this.state.filter.current.objectsType);
    return `/cards/${cardType}s/${encodeURIComponent(item.id)}/`;
  }

  rowClick(v) {
    this.$router.push({ path: this.getCardLink(v) });
  }

  hasObjectsConfidence() {
    return this.$store.getters.hasObjectsConfidence(this.objects || 'faces');
  }

  getMatchedObjectId(row) {
    return row.looks_like?.matched_object;
  }
  getConfidenceValue(row) {
    return row.looks_like?.confidence;
  }
}
</script>
